import { timeModel } from '~/models';
export const formatDigitalSignature = (approvalRecord)=>{
    return {
        signature: approvalRecord.signature,
        approvalSignature: approvalRecord.approvalSignature,
        on: "on ".concat(timeModel.formatDateWithTime(approvalRecord.timestamp, true)),
        ip: "(IP: ".concat(approvalRecord.ip, ")"),
        timestamp: approvalRecord.timestamp
    };
};
export const getSortedFormattedDigitalSignatures = (primaryApprovalRecord, signatoriesApprovalRecord)=>{
    return [
        primaryApprovalRecord,
        ...signatoriesApprovalRecord
    ].sort((a, b)=>{
        return a.timestamp - b.timestamp;
    }).map(formatDigitalSignature);
};
